"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.splitOnAnySubseq = splitOnAnySubseq;
exports.default = void 0;

var _iterable = require("../../internal/iterable");

var _stringSplitOnAny = require("../$split-on-any/internal/string-split-on-any");

var _iterableSplitOnAnySubseq = require("./internal/iterable-split-on-any-subseq");

function splitOnAnySubseq(source, separatorSubseqs) {
  return typeof source === 'string' ? (0, _stringSplitOnAny.stringSplitOnAny)(source, separatorSubseqs) : (0, _iterableSplitOnAnySubseq.iterableSplitOnAnySubseq)(source, separatorSubseqs);
}

var _default = (0, _iterable.iterableCurry)(splitOnAnySubseq);

exports.default = _default;